// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__29cCH","obliqueLineWrap":"membershipbadge_obliqueLineWrap___Kwxr","obliqueLine":"membershipbadge_obliqueLine__eWdP2"};